<div class="select-dealer">
  <vw-expand>
    <div header class="border-bottom">
      <div
        class="row dealer-top-title pb-3"
        *ngIf="
          modelAndDealerService.selectedDealer ||
          (channelRequestService.channelRequest &&
            channelRequestService.channelRequest.shoppingCart &&
            channelRequestService.channelRequest.shoppingCart.vehicle)
        "
      >
        <div
          class="col-10"
          [class.col-sm-8]="!channelRequestService.showModelName"
          *ngIf="modelAndDealerService.selectedDealer"
        >
          <span class="me-1">{{ "carAndDealer.dealer" | translate }}:</span>
          <span class="fw-bold dealer-top-title-value">{{
            modelAndDealerService.selectedDealer.name
          }}</span>
        </div>
        <div
          class="col-10 d-flex"
          [class.col-sm-4]="!channelRequestService.showModelName"
          [class.justify-content-sm-end]="
            modelAndDealerService.selectedDealer &&
            !channelRequestService.showModelName
          "
          *ngIf="
            channelRequestService.channelRequest &&
            channelRequestService.channelRequest.shoppingCart &&
            channelRequestService.channelRequest.shoppingCart.vehicle
          "
        >
          <span class="me-1">
            {{ "carAndDealer.regNrShort" | translate }}:
          </span>
          <span class="fw-bold">{{
            channelRequestService.channelRequest.shoppingCart.vehicle | vehicle
          }}</span>
        </div>
      </div>
    </div>
    <div>
      <p class="h4 fw-bold mb-3">
        {{ "carAndDealer.changeDealerOrRegNr" | translate }}
      </p>
    </div>
    <form [formGroup]="regNrForm" autocomplete="off" *ngIf="!vehicleByModel">
      <div class="row">
        <div class="col-12">
          <vw-text-box
            [label]="'changeRegNr' | translate"
            placeholder=""
            [parentForm]="regNrForm"
            [id]="'changeRegNr'"
            [type]="'text'"
            [buttonText]="''"
            [formControlProp]="'regNr'"
            [buttonDisabled]="false"
          >
            <div class="d-flex justify-content-between">
              <ng-template
                [ngTemplateOutlet]="searchModeTemplate"
              ></ng-template>
              <ng-template [ngTemplateOutlet]="clearVehicle"></ng-template>
            </div>
          </vw-text-box>
        </div>
      </div>
    </form>

    <form
      [formGroup]="modelAndDealerService.modelForm"
      autocomplete="off"
      *ngIf="vehicleByModel"
    >
      <div class="row">
        <div class="col-4">
          <vw-select
            [id]="'model-group'"
            [label]="'carAndDealer.modelGroup' | translate"
            [items]="modelAndDealerService.modelGroups"
            [template]="modelGroupTemplate"
            [parentForm]="modelAndDealerService.modelForm"
            [formControlProp]="'modelGroupId'"
            [emptyOption]="true"
          >
            <ng-template [ngTemplateOutlet]="searchModeTemplate"></ng-template>
          </vw-select>
        </div>

        <div class="col-4">
          <vw-select
            [id]="'year'"
            [label]="'carAndDealer.year' | translate"
            [items]="modelAndDealerService.years"
            [template]="yearTemplate"
            [parentForm]="modelAndDealerService.modelForm"
            [formControlProp]="'year'"
            [emptyOption]="true"
          ></vw-select>
        </div>

        <div class="col-4">
          <vw-select
            [id]="'model'"
            [label]="'carAndDealer.model' | translate"
            [items]="modelAndDealerService.models"
            [template]="modelTemplate"
            [parentForm]="modelAndDealerService.modelForm"
            [formControlProp]="'model'"
            [emptyOption]="true"
          ></vw-select>
        </div>
      </div>
    </form>

    <div class="row" *ngIf="dealersInMap.length">
      <div class="col-12">
        <div class="map">
          <vw-google-map
            [allLocations]="locations"
            [clientLocation]="clientLocation"
            [selectedLocation]="selectedLocation"
            (locationSelected)="onLocationSelect($event)"
            (locationSearched)="onLocationSearch($event)"
            (markerClick)="onLocationSelect($event)"
          ></vw-google-map>
        </div>

        <div class="dealers">
          <vw-toggleable
            *ngFor="let d of dealersInMap"
            [defaultToggled]="false"
          >
            <div header>
              <div class="name">
                <i
                  (click)="selectDealer(d)"
                  class="far fa-circle me-3 pointer"
                  *ngIf="changeDealerForm.value.selectedDealerId !== d.dealerId"
                ></i>
                <i
                  class="far fa-check-circle me-3"
                  *ngIf="changeDealerForm.value.selectedDealerId === d.dealerId"
                ></i>
                <span class="h6 mb-0 fw-bold">{{ d.name }}</span>
              </div>
              <div class="address">
                <span>{{ d.streetAddress }}, {{ d.city }}</span>
              </div>
            </div>

            <div class="info">
              <i class="fal fa-phone-alt fa-fw"></i>
              <a [href]="'tel:' + d.phone">{{ d.phone }}</a>
            </div>

            <div *ngIf="d.webSite" class="info">
              <i class="fal fa-external-link-alt fa-fw"></i>
              <a [href]="d.webSite | dealerWebsite" target="_blank">{{
                d.webSite | dealerWebsite
              }}</a>
            </div>

            <div class="info">
              <i class="fal fa-map-marked-alt fa-fw"></i>
              <a
                [href]="
                  [d.streetAddress, d.postalCode, d.city] | googleMapsLink
                "
                target="_blank"
              >
                {{ "selectDealer.showInGoogleMaps" | translate }}
              </a>
            </div>
          </vw-toggleable>
        </div>
      </div>
    </div>

    <div footer>
      <div class="row">
        <div class="col-12 justify-content-end d-flex">
          <vw-button
            (click)="save($event)"
            [text]="'save' | translate"
            [primary]="true"
            [small]="true"
            [rounded]="false"
            [disabled]="saving"
          ></vw-button>
          <vw-button
            *ngIf="
              channelRequestService.channelRequest?.shoppingCart?.vehicle ||
              modelAndDealerService.selectedDealer
            "
            class="ms-3"
            (click)="resetAll()"
            [text]="'reset' | translate"
            [primary]="false"
            [small]="true"
            [light]="true"
            [rounded]="false"
            [disabled]="saving"
          ></vw-button>
        </div>
      </div>
    </div>
  </vw-expand>

  <ng-template #dealerTemplate let-item="item">
    <div class="dealer-template">
      <i class="fal fa-map-marker-alt"></i>
      <div>
        <span
          [innerHTML]="item.name | highlight: changeDealerForm.value.dealer"
        >
        </span>
        <span
          class="city"
          [innerHTML]="item.city | highlight: changeDealerForm.value.dealer"
        ></span>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #searchModeTemplate>
  <span class="pointer text-decoration-underline" (click)="toggleSearch()">
    {{
      !vehicleByModel
        ? ("carAndDealer.searchByModel" | translate)
        : ("carAndDealer.searchByRegNr" | translate)
    }}
  </span>
</ng-template>

<ng-template #clearDealer>
  <span
    *ngIf="modelAndDealerService.selectedDealer"
    class="pointer text-decoration-underline text-danger"
    (click)="resetDealer()"
  >
    {{ "reset" | translate }}
  </span>
</ng-template>

<ng-template #clearVehicle>
  <span
    *ngIf="channelRequestService.channelRequest?.shoppingCart?.vehicle"
    class="pointer text-decoration-underline text-danger"
    (click)="resetVehicle()"
  >
    {{ "reset" | translate }}
  </span>
</ng-template>

<ng-template #yearTemplate let-item="item">
  <option [value]="item">
    {{ item }}
  </option>
</ng-template>

<ng-template #modelGroupTemplate let-item="item">
  <option [value]="item.modelGroupId">
    {{ item.name | titlecase }}
  </option>
</ng-template>

<ng-template #modelTemplate let-item="item">
  <option [value]="item.name">{{ item.name }} ({{ item.modelCode }})</option>
</ng-template>
